import { supabase } from "@/integrations/supabase/client";

const SUPABASE_URL = "https://evheflzvayrquurnvybm.supabase.co";

function generateCode(length = 7): string {
  const chars = "abcdefghijkmnpqrstuvwxyz23456789"; // no ambiguous chars
  let out = "";
  const bytes = crypto.getRandomValues(new Uint8Array(length));
  for (let i = 0; i < length; i++) out += chars[bytes[i] % chars.length];
  return out;
}

/**
 * Create a short link pointing to `targetUrl`. Returns the short URL,
 * or the original URL if shortening fails (so callers can always send something).
 */
export async function shortenUrl(
  targetUrl: string,
  userId?: string | null,
): Promise<string> {
  if (!targetUrl) return targetUrl;
  try {
    for (let attempt = 0; attempt < 3; attempt++) {
      const code = generateCode();
      const { error } = await supabase
        .from("short_links")
        .insert({ code, url: targetUrl, user_id: userId ?? null });
      if (!error) {
        return `${SUPABASE_URL}/functions/v1/s/${code}`;
      }
      // unique violation -> retry; other errors -> bail out
      if (!`${error.message}`.toLowerCase().includes("duplicate")) {
        console.warn("shortenUrl insert error:", error);
        break;
      }
    }
  } catch (e) {
    console.warn("shortenUrl failed:", e);
  }
  return targetUrl;
}
